<template>
    <div>
        <card-header title="Application Evaluation Summary" icon="fa-sparkles"/>

        <card-body padded v-html="summary" class="content pb-6">

        </card-body>
    </div>
</template>

<script>
    import {client as http} from "@/http_client";

    import CardList from "../../../TIER/components/CardList.vue";
    import CardHeader from "../../../TIER/components/CardHeader.vue";
    import CardBody from "../../../TIER/components/CardBody.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardBody, CardHeader, CardList},
        data() {
            return {
                loaded: false,
                summary: ''
            };
        },
        methods: {
            loadApp: function() {
                this.$emit('loading', true);
                http.get('applicants/application/' + this.props.appId + '/conf/' + this.props.confId + '/ai', {force: true}).then(response => {
                    this.summary = response.data.summary;
                    this.$emit('loading', false);
                    this.loaded = true;
                }).catch(err => {

                });
            }
        },
        mounted() {
            this.loadApp();
        }
    }
</script>

<style scoped lang="scss">

</style>
